module.exports = "dist/39b2c3031be6b4ea96e2e3e95d307814.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Bold.woff2
// module id = 220
// module chunks = 0